import { AppThunk } from '../../../../storage/store';
import { fetchStart, fetchSuccess, fetchFailed, setDownloadError } from './slice';
import { fetchVendorPaymentsAPI, downloadVendorPaymentsAPI } from './api';
import { VendorPaymentFilters } from '../../model/reports';
import { getToken } from '../../../../utils/auth';
import { triggerDownload } from '../../../../utils/download';

export const getVendorPayments = (filters: VendorPaymentFilters = {}): AppThunk => async (dispatch) => {
  dispatch(fetchStart());
  try {
    const token = getToken() || '';
    const data = await fetchVendorPaymentsAPI(token, filters);
    dispatch(fetchSuccess(data));
  } catch (err: any) {
    dispatch(fetchFailed(err?.message || 'Failed to load vendor payment report.'));
  }
};

export const downloadVendorPayments = (filters: VendorPaymentFilters = {}): AppThunk => async (dispatch) => {
  dispatch(setDownloadError(null));
  try {
    const token = getToken() || '';
    const { blob, filename } = await downloadVendorPaymentsAPI(token, filters);
    triggerDownload(blob, filename);
  } catch (err: any) {
    dispatch(setDownloadError(err?.message || 'Download failed. Please try again.'));
  }
};
